import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import ConfirmDialog from "../../components/ConfirmDialog";

const BranchesList = () => {
  const [branches, setBranches] = useState([]);
  const [open, setOpen] = useState(false);

  const [branchName, setBranchName] = useState("");
  const [address, setAddress] = useState("");
  const [error, setError] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState("");
  const [editBranch, setEditBranch] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getBranchList();
  }, []);

  const handleAddBranch = async () => {
    try {
      setSaving(true);
      if (!branchName.trim()) {
        setError("Branch name is required");
        setSaving(false)
        return;
      }

      const payload = {
        name: branchName,
        address: address,
      };

      let path = "/branches/create";

      if (editBranch) {
        path = "/branches/update/" + selectedBranchId;
      }

      const response = await axiosInstance.post(path, payload);

      toast.success(response?.data?.message || "Branch saved succesfully");

      getBranchList();
      closeAddBranchPopup();
      setSaving(false);
    } catch (error) {
      setSaving(false);
      toast.error(
        error.response?.data?.message ||
          "Something went wrong, try again after sometime"
      );
    }
  };

  const closeAddBranchPopup = () => {
    setOpen(false);
    setError("");
    setBranchName("");
    setAddress("");
    setEditBranch(false);
  };

  const getBranchList = async () => {
    try {
      const response = await axiosInstance.get("/branches");

      setBranches(response?.data?.list);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error retrieving list");
    }
  };

  const openEditBranchPopup = (branch) => {
    setEditBranch(true);
    setSelectedBranchId(branch?._id);
    setBranchName(branch?.name);
    setAddress(branch?.address);
    setOpen(true);
  };

  const handleDeleteBranch = async () => {
    try {
      await axiosInstance.delete("branches/" + selectedBranchId);
      getBranchList();
      setOpenDelete(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <Box p={3}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h5" fontWeight="bold">
          Branches
        </Typography>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpen(true)}
        >
          Add Branch
        </Button>
      </Box>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                }}
              >
                <b>Branch Name</b>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                }}
              >
                <b>Address</b>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                }}
              >
                <b>Actions</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {branches.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  No branches found
                </TableCell>
              </TableRow>
            ) : (
              branches.map((branch) => (
                <TableRow key={branch.id}>
                  <TableCell>{branch.name}</TableCell>
                  <TableCell>{branch.address || "-"}</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      onClick={() => openEditBranchPopup(branch)}
                    >
                      <FaEdit size={19} />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => {
                        setSelectedBranchId(branch?._id);
                        setOpenDelete(true);
                      }}
                    >
                      <FaTrash size={16} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Add Branch Dialog */}
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle
          variant="h6"
          fontWeight="bold"
          sx={{
            background: "#f5f5f5",
          }}
        >
          {editBranch ? "Edit Branch" : "Add Branch"}
        </DialogTitle>

        <DialogContent>
          <TextField
            label="Branch Name"
            required
            fullWidth
            margin="normal"
            value={branchName}
            onChange={(e) => setBranchName(e.target.value)}
            error={!!error}
            helperText={error}
          />

          <TextField
            label="Address"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => closeAddBranchPopup()}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleAddBranch}
            disabled={saving}
          >
            {saving ? "Saving" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmDialog
        open={openDelete}
        onClose={()=>setOpenDelete(false)}
        onConfirm={handleDeleteBranch}
        message={`Are you sure you want to delete Branch?`}
      />
    </Box>
  );
};

export default BranchesList;